export let imgs = [
  require('@/assets/images/back.png'),
  require('@/assets/images/btn/btn-bg.png'),
  require('@/assets/images/confirm/abort-bg.png'),
  require('@/assets/images/confirm/succ-bg.png'),
  require('@/assets/images/confirm/succ-bg1.png'),
  require('@/assets/images/confirm/succ-bg2.png'),
  require('@/assets/images/confirm/succ-bg3.png'),
  require('@/assets/images/confirm/succ-bg4.png'),
  require('@/assets/images/confirm/succ-bg5.png'),
  require('@/assets/images/cube/intro1.png'),
  require('@/assets/images/cube/intro2.png'),
  require('@/assets/images/cube/star.png'),
  require('@/assets/images/cube/bg-cube.jpg'),
  require('@/assets/images/daybook/autograph.png'),
  require('@/assets/images/daybook/bg-solid/l1.png'),
  require('@/assets/images/daybook/bg.jpg'),
  require('@/assets/images/daybook/delete.png'),
  require('@/assets/images/daybook/input-bg.png'),
  require('@/assets/images/daybook/intro1.png'),
  require('@/assets/images/daybook/intro2.png'),
  require('@/assets/images/daybook/tips.png'),
  require('@/assets/images/daybook/txt.png'),
  require('@/assets/images/daybook/txt1.png'),
  require('@/assets/images/daybook/txt2.png'),
  require('@/assets/images/end/bg.jpg'),
  require('@/assets/images/entrance/entrance-bg.jpg'),
  require('@/assets/images/entrance/form-bg.png'),
  require('@/assets/images/entrance/input-bg.png'),
  require('@/assets/images/entrance/key-text.png'),
  require('@/assets/images/entrance/sucess-bg.png'),
  require('@/assets/images/fake/missionEnd-1-b.png'),
  require('@/assets/images/fake/missionEnd-1-w.png'),
  require('@/assets/images/fake/missionEnd-1.jpg'),
  require('@/assets/images/fake/missionEnd-2-b.png'),
  require('@/assets/images/fake/missionEnd-2-bg.jpg'),
  require('@/assets/images/fake/missionEnd-2-w.png'),
  require('@/assets/images/fake/missionEnd-2.jpg'),
  require('@/assets/images/fake/missionEnd-3-b.png'),
  require('@/assets/images/fake/missionEnd-3-w.png'),
  require('@/assets/images/fake/missionEnd-bg.jpg'),
  require('@/assets/images/fake/missionStart.jpg'),
  require('@/assets/images/form/bg.jpg'),
  require('@/assets/images/form/check.png'),
  require('@/assets/images/form/checked.png'),
  require('@/assets/images/form/form.png'),
  require('@/assets/images/form/tk1.png'),
  require('@/assets/images/form/tk2.png'),
  require('@/assets/images/graphical/-1.png'),
  require('@/assets/images/graphical/11.png'),
  require('@/assets/images/graphical/3.png'),
  require('@/assets/images/graphical/5.png'),
  require('@/assets/images/graphical/bg.jpg'),
  require('@/assets/images/graphical/box-bg.png'),
  require('@/assets/images/graphical/box.png'),
  require('@/assets/images/graphical/intro1.png'),
  require('@/assets/images/graphical/intro2.png'),
  require('@/assets/images/graphical/load-mask.png'),
  require('@/assets/images/graphical/subject/1.png'),
  require('@/assets/images/graphical/subject/2.png'),
  require('@/assets/images/graphical/subject/3.png'),
  require('@/assets/images/graphical/subject/4.png'),
  require('@/assets/images/graphical/subject/5.png'),
  require('@/assets/images/graphical/subject/6.png'),
  require('@/assets/images/graphical/subject/7.png'),
  require('@/assets/images/graphical/subject/box1.png'),
  require('@/assets/images/graphical/subject/box2.png'),
  require('@/assets/images/graphical/subject/box3.png'),
  require('@/assets/images/graphical/subject/box4.png'),
  require('@/assets/images/graphical/txt.png'),
  require('@/assets/images/graphical/txt2.png'),
  require('@/assets/images/home/1-1.png'),
  require('@/assets/images/home/1-2.png'),
  require('@/assets/images/home/2-1.png'),
  require('@/assets/images/home/2-2.png'),
  require('@/assets/images/home/3-1.png'),
  require('@/assets/images/home/award-active.png'),
  require('@/assets/images/home/award-lock.png'),
  require('@/assets/images/home/border.png'),
  require('@/assets/images/home/detail1.jpg'),
  require('@/assets/images/home/detail10.jpg'),
  require('@/assets/images/home/detail3.jpg'),
  require('@/assets/images/home/detail4.jpg'),
  require('@/assets/images/home/detail5.jpg'),
  require('@/assets/images/home/detail6.jpg'),
  require('@/assets/images/home/detail7.jpg'),
  require('@/assets/images/home/detail8.jpg'),
  require('@/assets/images/home/detail9.jpg'),
  require('@/assets/images/home/divider.png'),
  require('@/assets/images/home/home-bg.jpg'),
  require('@/assets/images/home/item-time-bg.png'),
  require('@/assets/images/home/kv-banner1.jpg'),
  require('@/assets/images/home/kv-banner2.jpg'),
  require('@/assets/images/home/kv-banner3.jpg'),
  require('@/assets/images/home/kv-banner4.jpg'),
  require('@/assets/images/home/kv-bg.png'),
  require('@/assets/images/home/lock.png'),
  require('@/assets/images/home/logo.png'),
  require('@/assets/images/home/mission-bg.png'),
  require('@/assets/images/home/mission-item-bg-locked.png'),
  require('@/assets/images/home/mission-item-bg.png'),
  require('@/assets/images/home/music.png'),
  require('@/assets/images/home/progress-bg.png'),
  require('@/assets/images/home/rule1.jpg'),
  require('@/assets/images/home/rule2.jpg'),
  require('@/assets/images/home/rule3.jpg'),
  require('@/assets/images/home/rule4.jpg'),
  require('@/assets/images/home/rule5.jpg'),
  require('@/assets/images/home/rule6.jpg'),
  require('@/assets/images/home/rule7.jpg'),
  require('@/assets/images/home/video2.jpg'),
  require('@/assets/images/intro/bg.jpg'),
  require('@/assets/images/intro/boss-bg-h.jpg'),
  require('@/assets/images/intro/boss-bg.jpg'),
  require('@/assets/images/intro/cloud1.png'),
  require('@/assets/images/intro/cloud2.png'),
  require('@/assets/images/intro/code.png'),
  require('@/assets/images/intro/save.png'),
  require('@/assets/images/intro/word.png'),
  require('@/assets/images/keyboard/keyboard-bg.png'),
  require('@/assets/images/load/load-bg.jpg'),
  require('@/assets/images/load/loading/bg1.png'),
  require('@/assets/images/load/loading/bg10.png'),
  require('@/assets/images/load/loading/bg11.png'),
  require('@/assets/images/load/loading/bg12.png'),
  require('@/assets/images/load/loading/bg13.png'),
  require('@/assets/images/load/loading/bg14.png'),
  require('@/assets/images/load/loading/bg15.png'),
  require('@/assets/images/load/loading/bg16.png'),
  require('@/assets/images/load/loading/bg17.png'),
  require('@/assets/images/load/loading/bg18.png'),
  require('@/assets/images/load/loading/bg19.png'),
  require('@/assets/images/load/loading/bg2.png'),
  require('@/assets/images/load/loading/bg20.png'),
  require('@/assets/images/load/loading/bg21.png'),
  require('@/assets/images/load/loading/bg22.png'),
  require('@/assets/images/load/loading/bg23.png'),
  require('@/assets/images/load/loading/bg24.png'),
  require('@/assets/images/load/loading/bg25.png'),
  require('@/assets/images/load/loading/bg26.png'),
  require('@/assets/images/load/loading/bg27.png'),
  require('@/assets/images/load/loading/bg28.png'),
  require('@/assets/images/load/loading/bg29.png'),
  require('@/assets/images/load/loading/bg3.png'),
  require('@/assets/images/load/loading/bg30.png'),
  require('@/assets/images/load/loading/bg31.png'),
  require('@/assets/images/load/loading/bg32.png'),
  require('@/assets/images/load/loading/bg33.png'),
  require('@/assets/images/load/loading/bg34.png'),
  require('@/assets/images/load/loading/bg35.png'),
  require('@/assets/images/load/loading/bg36.png'),
  require('@/assets/images/load/loading/bg37.png'),
  require('@/assets/images/load/loading/bg38.png'),
  require('@/assets/images/load/loading/bg39.png'),
  require('@/assets/images/load/loading/bg4.png'),
  require('@/assets/images/load/loading/bg40.png'),
  require('@/assets/images/load/loading/bg41.png'),
  require('@/assets/images/load/loading/bg42.png'),
  require('@/assets/images/load/loading/bg43.png'),
  require('@/assets/images/load/loading/bg44.png'),
  require('@/assets/images/load/loading/bg45.png'),
  require('@/assets/images/load/loading/bg5.png'),
  require('@/assets/images/load/loading/bg6.png'),
  require('@/assets/images/load/loading/bg7.png'),
  require('@/assets/images/load/loading/bg8.png'),
  require('@/assets/images/load/loading/bg9.png'),

  require('@/assets/images/maze/intro1.png'),
  require('@/assets/images/maze/intro2.png'),
  require('@/assets/images/maze/reset.png'),
  require('@/assets/images/maze/tip.png'),

  require('@/assets/images/shareImg.jpg'),

  require('@/assets/images/sudoku/intro1.png'),
  require('@/assets/images/sudoku/intro2.png'),
  require('@/assets/images/sudoku/rule-btn.png'),
  require('@/assets/images/sudoku/sudoku-bg.jpg'),
  require('@/assets/images/sudoku/sudoku-bg.png'),
  require('@/assets/images/sudoku/tip-btn.png'),
];
